
import Auth from '@/components/auth';
import { getSiteSettings } from '@/lib/getSiteSettings';
import { NextSeo } from 'next-seo';

export async function getStaticProps() {
  const siteSettings = await getSiteSettings();
  return {
    props: {
      siteSettings,
    },
    revalidate: 60,
  };
}

export default function AuthPage() {

  return (
    <div style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <NextSeo
        title="Login to Your Account | Purple Lotus Dispensary"
        description="Sign in to your Purple Lotus account to manage orders, save favorites, and access exclusive cannabis rewards. Fast and secure login."
        canonical="https://plpcsanjose.com/login"
        openGraph={{
          url: "https://plpcsanjose.com/login",
          title: "Login to Your Account | Purple Lotus Dispensary",
          description:
            "Sign in to your Purple Lotus account to manage orders, save favorites, and access exclusive cannabis rewards. Fast and secure login.",
          siteName: "Purple Lotus",
        }}
      />
      <Auth view={"signIn"} />
    </div>
  );
};
